// Sliders with loop enabled clone their slides, so the same drawer is mounted
// several times with the same modal id. Only the first one may open.
const openIds = new Set();

export default () => ({
  open: false,

  get modalId() {
    return this.$root.dataset.modalId || "";
  },

  hide() {
    if (this.modalId) openIds.delete(this.modalId);
    this.open = false;
    setTimeout(() => this.toggleBodyClass(false), 500);
  },

  show() {
    if (this.modalId) {
      if (openIds.has(this.modalId)) return;
      openIds.add(this.modalId);
    }
    this.open = true;
    this.toggleBodyClass(true);
  },

  destroy() {
    if (this.open && this.modalId) openIds.delete(this.modalId);
  },

  toggleBodyClass(addBodyClass) {
    const body = document.querySelector("body");
    if (addBodyClass) {
      body.classList.add("modal-open");
    } else {
      body.classList.remove("modal-open");
    }
  },
});
